import React from 'react';
import './ModuleCatalog.css';
import PowerSupply from './modelFunc/components/cards/PowerSupply';
import UltraScaleComputer from './modelFunc/components/cards/UltraScaleComputer';
import ComputerSupervisor from './modelFunc/components/cards/ComputerSupervisor';
import VersalDataHandling from './modelFunc/components/cards/VersalDataHandling';
import ClearAll from './modelFunc/components/Button/ClearAll';
import Generic4ETH from './modelFunc/components/cards/Generic4ETH';
import Scorpyos from './modelFunc/components/cards/Scorpyos';
import GenericIOS from './modelFunc/components/cards/GenericIOS';
import GenericHPC from './modelFunc/components/cards/GenericHPC';
import { Box } from '@mui/material';
import toast from "react-hot-toast";

const ModuleCatalog = ({ availableModules, currentRack, setCurrentRack, reset, setReset }) => {


  const handleAddModule = (module) => {
    const { rackModel, modules } = currentRack;

    const newModules = rackModel.addModule(module, modules);

    if (newModules) {
      setCurrentRack({ ...currentRack, modules: newModules });
      return module;
    } else {
      toast.error(`No available slot for ${module.id}`);
    }
  };

  const AddSingleModule = (module) => {
    const { rackModel, modules } = currentRack;
    console.log('Current Rack Modules:', modules, rackModel);
    let updatedModules = {};
    if (module.id === "powernom") {
      updatedModules = { ...modules, '0A': module, '0B': null };
    }
    if (module.id === "supervisor") {
      updatedModules = { ...modules, '5': module, '6': null };
    }
    setCurrentRack({ ...currentRack, modules: updatedModules });
    return module;
  };

  const AddRedundantModule = (module) => {
    const { rackModel, modules } = currentRack;
    console.log('Current Rack Modules:', modules, rackModel);
    let updatedModules = {};
    if (module.id === "powernom") {
      updatedModules = { ...modules, '0A': module, '0B': module };
    }
    if (module.id === "supervisor") {
      updatedModules = { ...modules, '5': module, '6': module };
    }
    setCurrentRack({ ...currentRack, modules: updatedModules });
    return module;
  };

  const handleDecrementModule = (module) => {
    const { rackModel, modules } = currentRack;

    const slotsWithModule = Object.entries(modules)
      .filter(([slot, mod]) => mod?.id === module.id)
      .map(([slot]) => slot);

    if (slotsWithModule.length === 0) {
      toast(`No ${module.id} modules to remove.`, { icon: "⚠️" });
      return;
    }

    const lastSlot = slotsWithModule[slotsWithModule.length - 1];

    const newModules = rackModel.removeModule(lastSlot, modules);
    setCurrentRack({ ...currentRack, modules: newModules });
  };

  return (
    <Box className='containerCatalogo'>
      <h2 className='ConfigurationH2'>Configurations</h2>
      <PowerSupply handleBasePower={AddSingleModule} handleRedundantPower={AddRedundantModule} module={availableModules[1]} handleDecrement={handleDecrementModule} reset={reset} />
      <UltraScaleComputer handleNominalUltraScale={handleAddModule} module={availableModules[4]} handleDecrement={handleDecrementModule} reset={reset} />
      <ComputerSupervisor handleNominalSupervisor={AddSingleModule} handleRedundantSupervisor={AddRedundantModule} module={availableModules[5]} handleDecrement={handleDecrementModule} reset={reset} />
      <Scorpyos handleGeneric={handleAddModule} module={availableModules[7]} handleDecrement={handleDecrementModule} reset={reset} />
      <VersalDataHandling handleVersal={handleAddModule} module={availableModules[3]} handleDecrement={handleDecrementModule} reset={reset} />
      <Generic4ETH handleGeneric={handleAddModule} module={availableModules[6]} handleDecrement={handleDecrementModule} reset={reset} />
      <GenericIOS handleGeneric={handleAddModule} module={availableModules[2]} handleDecrement={handleDecrementModule} reset={reset} />
      <GenericHPC handleGeneric={handleAddModule} module={availableModules[0]} handleDecrement={handleDecrementModule} reset={reset} />
      <Box style={{ marginBottom: '20px', justifyContent: 'flex-end', position: 'relative', left: '31.5%' }}>
        <ClearAll
          onClear={() => {
            setReset(!reset);
            setCurrentRack({
              rackModel: currentRack.rackModel,
              modules: currentRack.rackModel.slots.reduce((acc, slot) => {
                acc[slot] = null;
                return acc;
              }, {})
            });
          }}
        />
      </Box>
    </Box>
  );
};

export default ModuleCatalog;